import { Link } from 'react-router-dom';
import CtaBand from '../components/CtaBand';
import Icon from '../components/Icon';
import Layout, { PageHero } from '../components/Layout';
import { PROCESS, SERVICES } from '../constants/content';
import { guidePath } from '../constants/guides';

const DETAILS = {
  'Installation & Setup': ['install-family-tree-maker-on-windows', 'install-family-tree-maker-on-mac'],
  'Activation & Licensing': ['activation-and-serial-number-problems'],
  'FamilySync & Ancestry': ['fix-familysync-errors', 'ancestry-sign-in-problems'],
  'TreeVault & Backups': ['treevault-cloud-backup-guide', 'backup-and-restore-your-tree'],
  'Photos & Media': ['relink-missing-media'],
  'Charts, Reports & Books': ['printing-charts-and-family-books'],
};

const ALSO = [
  'Moving trees and photos to a new computer',
  'Importing and exporting GEDCOM files',
  'Upgrading from FTM 2014, 2017, or 2019 to 2024',
  'Compacting and repairing slow or damaged trees',
  'Merging duplicate people safely',
  'Setting up FamilySearch tree matching',
  'Windows and macOS update compatibility',
  'Organising media folders so links never break',
];

export default function SupportServicesPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="Support services"
        title="Help for every part of Family Tree Maker"
        lead="Choose the area you need help with, read the free guide, or open live chat and let a technician walk you through it."
        crumbs={[{ label: 'Support Services' }]}
      />

      <section className="section">
        <div className="container">
          <div className="service-rows">
            {SERVICES.map((s) => (
              <article key={s.title} className="service-row">
                <span className="service-card__icon">
                  <Icon name={s.icon} size={28} />
                </span>
                <div>
                  <h2>{s.title}</h2>
                  <p>{s.text}</p>
                  <ul className="inline-links">
                    {(DETAILS[s.title] || []).map((slug) => (
                      <li key={slug}>
                        <Link to={guidePath(slug)}>Read the guide →</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--parchment">
        <div className="container split">
          <div className="split__copy">
            <p className="eyebrow">And much more</p>
            <h2>Other things we regularly help with</h2>
            <ul className="tick-list">
              {ALSO.map((item) => (
                <li key={item}>
                  <Icon name="check" size={18} /> {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="split__media">
            <img src="/images/devices.webp" alt="Family Tree Maker shown on a laptop and desktop" width="640" height="480" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <p className="eyebrow">How it works</p>
            <h2>Four simple steps</h2>
          </div>
          <ol className="process">
            {PROCESS.map((step, i) => (
              <li key={step.title}>
                <span className="process__num">{i + 1}</span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </li>
            ))}
          </ol>
          <p className="note center">
            Free guidance is always available. If a paid session is needed, the price is explained and
            agreed with you before any work begins. See our <Link to="/refund-policy">Refund Policy</Link>.
          </p>
        </div>
      </section>

      <CtaBand />
    </Layout>
  );
}
